<template>
  <div class="form-group">
    <label> {{ label }} </label>
    <BuscarSelecionar
      :id="id"
      :lista="medicos"
      :selecionado="medico"
      :minimo="minimo"
      @selecionar="selecionarMedico"
      @limpar="limparMedico"
      @recuperar="recuperarMedicos"
    />
  </div>
</template>

<script>
import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import MedicoServico from '@/servicos/MedicoServico'

const medicoServico = new MedicoServico()

export default {
  name: 'BuscarSelecionarMedico',
  components: { BuscarSelecionar },
  props: {
    label: {
      type: String,
      default: 'Médico',
    },
    id: {
      type: String,
      default: 'medico',
    },
    minimo: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      medico: {},
      medicos: [],
    }
  },
  methods: {
    selecionarMedico(medico) {
      this.$emit('selecionadoMedico', medico)
    },
    limparMedico() {
      this.medico = {}
    },
    recuperarMedicos(filtro) {
      medicoServico
        .recuperarTodos({
          nome: filtro.palavra,
          skip: (filtro.pagina - 1) * filtro.limite,
          limit: filtro.limite,
          orderBy: filtro.chave,
        })
        .then((result) => {
          this.medicos = result.medicos
        })
    },
  },
}
</script>
